export const CAMERA_STRINGS = {
  default: 'Take a photo!',
  document: 'Take a photo of the document!',
  id: 'Take a photo of your ID!',
  passport: 'Take a photo of your ID page!',
  selfie: 'Take a selfie!',
  home: 'Take a photo of the front of your home!',
};
